import request from "../../assets/js/Request.js";
// import qs from 'qs'
// export const userLogin = (params) => {
//   return request.post("loginPc", qs.stringify(params),{headers: {'Content-Type':'application/x-www-form-urlencoded'}});
// };

// 发送验证码
export const spendCode = (params) => {
  return request.post("send-code", params);
};
// PC注册
export const registerUserPc = (params) => {
  return request.post("user/register", params);
};
// 验证码/密码登录
export const userLogin = (params) => {
  return request.post("user/login", params);
};
// 微信授权登录 ticket:uidcenter项目微信授权通过后返回的ticket
export const loginTicket = (params) => {
  return request.post(`user/wechat-login`, params);
};
// 退出登录
export const outLogin = (params) => {
  return request.post("user/logout", params);
};

// 判断登录状态
export const checkState = (params) => {
  return request.post("checkState", params);
};
// 绑定手机
export const bindingMobile = (params) => {
  return request.post("user/bind-mobile", params);
};
